import { X } from "lucide-react";
import { API } from "@/lib/api";
import { reportSessionText } from "@/components/Cycle";

export const REPORT_SECTIONS = [
  ["clinical_presentation", "Clinical presentation"],
  ["intervention", "Physiotherapy intervention"],
  ["clinical_response", "Clinical response"],
  ["education", "Education & post-exercise advice"],
  ["plan_of_care", "Plan of care"],
];

export const reportPdfUrl = (id) => `${API}/visit-reports/${id}/pdf?auth=${localStorage.getItem("praniq_token")}`;

function Info({ label, value }) {
  return (
    <div className="flex justify-between gap-4 py-1.5 border-b border-dashed border-slate-100 last:border-0 text-[12.5px]">
      <span className="text-slate-500">{label}</span><span className="font-semibold text-right">{value || "—"}</span>
    </div>
  );
}

export function VisitReportView({ r }) {
  const agesex = [r.patient_age ? `${r.patient_age} years` : "", r.patient_gender || ""].filter(Boolean).join(" / ");
  const hw = [r.height ? `${r.height} cm` : "", r.weight ? `${r.weight} kg` : ""].filter(Boolean).join(" / ");
  return (
    <div data-testid={`visit-report-body-${r.id}`}>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-x-8 mb-4">
        <Info label="Patient" value={r.patient_name} />
        <Info label="Visit" value={`${r.visit_date || ""}${r.visit_start ? `, ${r.visit_start}${r.visit_end ? `–${r.visit_end}` : ""}` : ""}`} />
        <Info label="Location" value={r.location} />
        <Info label="Clinician" value={`${r.clinician_name}, Physiotherapist`} />
        <Info label="Diagnosis" value={r.diagnosis} />
        <Info label="Age / Sex" value={agesex} />
        <Info label="Session" value={reportSessionText(r)} />
        <Info label="Height / Weight" value={hw} />
      </div>
      {REPORT_SECTIONS.map(([k, label], i) => (
        <div key={k} className="mb-3" data-testid={`visit-report-section-${k}`}>
          <div className="pq-label mb-1">{i + 1}. {label}</div>
          <div className="space-y-1">
            {(r.sections?.[k] || "").split("\n").filter((l) => l.trim()).map((l, j) => (
              <div key={j} className="flex gap-2 text-[12.5px] text-slate-700"><span className="text-teal-600 font-bold">•</span><span>{l}</span></div>
            ))}
          </div>
        </div>
      ))}
      <div className="mt-4 pt-3 border-t border-slate-200 text-[12px] text-slate-500">
        Home visit report by: <b>{r.clinician_name}, Physiotherapist</b> · Report date: {r.visit_date || (r.created_at || "").slice(0, 10)}
      </div>
    </div>
  );
}

export default function VisitReportModal({ r, onClose, actions }) {
  return (
    <div className="fixed inset-0 z-50 flex items-start justify-center bg-slate-900/50 backdrop-blur-sm p-4 overflow-y-auto" onMouseDown={onClose} data-testid="visit-report-modal">
      <div onMouseDown={(e) => e.stopPropagation()} className="bg-white rounded-2xl shadow-2xl w-full max-w-2xl my-8">
        <div className="flex items-start justify-between px-6 py-4 border-b border-slate-100 sticky top-0 bg-white rounded-t-2xl z-10">
          <div>
            <h3 className="font-display font-bold text-[17px] text-slate-900">Physiotherapy treatment & visit feedback</h3>
            <p className="text-[12.5px] text-slate-500 mt-0.5">Home-based physiotherapy record — {r.patient_name} · Session {reportSessionText(r)}</p>
          </div>
          <button onClick={onClose} data-testid="visit-report-close" className="text-slate-400 hover:text-slate-700"><X size={20} /></button>
        </div>
        <div className="px-6 py-5">
          <VisitReportView r={r} />
          {actions && <div className="flex gap-2 mt-4 pt-3 border-t border-slate-100">{actions}</div>}
        </div>
      </div>
    </div>
  );
}
